<template>
  <div class="c_cover">
    <el-dialog
      title="批注编辑"
      :visible.sync="centerDialogVisible"
      width="50%"
      @close="close"
      v-dialogDrag
      :modal="false"
      :show-close="false"
    >
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="扣分项" name="扣分项">
          <div class="first-el-tab">
            <el-tabs
              v-model="activeSecondName"
              @tab-click="handleSecondClick"
              tab-position="left"
              style="height: 350px;"
            >
              <el-tab-pane
                v-for="(item, i) in deductMarks"
                :key="i"
                :label="item.label"
                :name="item.label"
                class="second_err"
              >
                <el-row>
                  <el-col :span="8">
                    <div class="grid-content bg-purple">
                      <el-radio-group v-model="radioValue">
                        <el-radio-button
                          v-for="(value, j) in item.children"
                          :key="j"
                          :label="value.label"
                        ></el-radio-button>
                      </el-radio-group>
                    </div>
                  </el-col>
                  <el-col :span="16">
                    <div class="grid-content bg-purple-light">
                      <div>{{ radioValue }}</div>
                      <el-input
                        v-model="text"
                        type="textarea"
                        resize="none"
                        rows="9"
                        placeholder="请输入批注信息(最大输入200字符)"
                        maxlength="200"
                        style="font-size:16px;border:0;"
                      ></el-input>
                    </div>
                  </el-col>
                </el-row>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-tab-pane>
        <el-tab-pane label="加分项" name="加分项">
          <div class="first-el-tab">
            <el-row>
              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <el-radio-group v-model="radioValue">
                    <el-radio-button
                      v-for="(value, j) in extraPoints"
                      :key="j"
                      :label="value.label"
                    ></el-radio-button>
                  </el-radio-group>
                </div>
              </el-col>
              <el-col :span="16">
                <div class="grid-content bg-purple-light">
                  <div>{{ radioValue }}</div>
                  <el-input
                    v-model="text"
                    type="textarea"
                    resize="none"
                    rows="9"
                    placeholder="请输入批注信息(最大输入200字符)"
                    maxlength="200"
                    style="font-size:16px;border:0;"
                  ></el-input>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-tab-pane>
        <el-tab-pane label="其他项" name="其他项">
          <div class="grid-content bg-purple-light others-tab">
            <el-input
              v-model="text"
              type="textarea"
              resize="none"
              rows="9"
              placeholder="请输入批注信息(最大输入200字符)"
              maxlength="200"
              style="font-size:16px;border:0;"
            ></el-input>
          </div>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px;" type="primary" @click="handleConfirm">
          确 定
        </el-button>
        <el-button
          style="width:120px;"
          type="info"
          @click="centerDialogVisible = false"
        >
          取消
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// import $ from "jquery";
// import axios from "axios";
export default {
  props: {
    show: Boolean,
    conceal: Function,
    confirm: Function,
    handleClose: Function
  },
  watch: {
    show: {
      handler(val) {
        if (val) {
          this.centerDialogVisible = val;
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      activeName: "扣分项",
      activeSecondName: "拼写错误",
      centerDialogVisible: false,
      radioValue: "",
      text: "",
      extraPoints: [
        // 加分项类型
        {
          value: "高级词汇",
          label: "高级词汇"
        },
        {
          value: "同义表达多样",
          label: "同义表达多样"
        },
        {
          value: "表达地道",
          label: "表达地道"
        },
        {
          value: "句式多样正确",
          label: "句式多样正确"
        },
        {
          value: "名言使用恰当",
          label: "名言使用恰当"
        },
        {
          value: "衔接流畅",
          label: "衔接流畅"
        },
        {
          value: "篇章结构清晰",
          label: "篇章结构清晰"
        },
        {
          value: "论点新颖",
          label: "论点新颖"
        },
        {
          value: "紧扣主题",
          label: "紧扣主题"
        },
        {
          value: "使用修辞",
          label: "使用修辞"
        }
      ],
      deductMarks: [
        //扣分项类型
        {
          value: "拼写错误",
          label: "拼写错误",
          children: [
            {
              value: "大小写错误",
              label: "大小写错误"
            },
            {
              value: "缩写错误",
              label: "缩写错误"
            },
            {
              value: "没有此词",
              label: "没有此词"
            },
            {
              value: "拼写错误",
              label: "拼写错误"
            }
          ]
        },
        {
          value: "语法错误",
          label: "语法错误",
          children: [
            {
              value: "搭配错误",
              label: "搭配错误"
            },
            {
              value: "并列结构错误",
              label: "并列结构错误"
            },
            {
              value: "词性错误",
              label: "词性错误"
            },
            {
              value: "连词错误",
              label: "连词错误"
            },
            {
              value: "限定词错误",
              label: "限定词错误"
            },
            {
              value: "数词错误",
              label: "数词错误"
            },
            {
              value: "代词错误",
              label: "代词错误"
            },
            {
              value: "代词不一致",
              label: "代词不一致"
            },
            {
              value: "介词错误",
              label: "介词错误"
            },
            {
              value: "冠词错误",
              label: "冠词错误"
            },
            {
              value: "单复数错误",
              label: "单复数错误"
            },
            {
              value: "所有格错误",
              label: "所有格错误"
            },
            {
              value: "主谓不一致",
              label: "主谓不一致"
            },
            {
              value: "时态不一致",
              label: "时态不一致"
            },
            {
              value: "时态错误",
              label: "时态错误"
            },
            {
              value: "动词形式错误",
              label: "动词形式错误"
            },
            {
              value: "语态错误",
              label: "语态错误"
            },
            {
              value: "比较级使用错误",
              label: "比较级使用错误"
            },
            {
              value: "复合句结构错误",
              label: "复合句结构错误"
            }
          ]
        },
        {
          value: "语义错误",
          label: "语义错误",
          children: [
            {
              value: "措辞错误",
              label: "措辞错误"
            },
            {
              value: "意义不明",
              label: "意义不明"
            },
            {
              value: "褒贬错误",
              label: "褒贬错误"
            },
            {
              value: "指代不明",
              label: "指代不明"
            },
            {
              value: "歧义",
              label: "歧义"
            }
          ]
        },
        {
          value: "语用错误",
          label: "语用错误",
          children: [
            {
              value: "中式英语",
              label: "中式英语"
            },
            {
              value: "文化差异",
              label: "文化差异"
            },
            {
              value: "口语化",
              label: "口语化"
            }
          ]
        },
        {
          value: "结构错误",
          label: "结构错误",
          children: [
            {
              value: "逻辑错误",
              label: "逻辑错误"
            },
            {
              value: "标点错误",
              label: "标点错误"
            },
            {
              value: "断句错误",
              label: "断句错误"
            },
            {
              value: "不完整句",
              label: "不完整句"
            },
            {
              value: "成分多余",
              label: "成分多余"
            },
            {
              value: "词序错误",
              label: "词序错误"
            },
            {
              value: "语句不通顺",
              label: "语句不通顺"
            },
            {
              value: "语序调换",
              label: "语序调换"
            }
          ]
        },
        {
          value: "内容错误",
          label: "内容错误",
          children: [
            {
              value: "内容重复",
              label: "内容重复"
            },
            {
              value: "内容不相关",
              label: "内容不相关"
            }
          ]
        },
        {
          value: "其他错误",
          label: "其他错误",
          children: [
            {
              value: "其他错误",
              label: "其他错误"
            }
          ]
        }
      ]
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {},
    handleClick() {
      if (this.activeName === "其他项") {
        this.radioValue = this.activeName;
      } else {
        this.radioValue = "";
      }
    },
    handleSecondClick() {
      this.radioValue = "";
    },
    close() {
      this.handleClose();
      // 关闭批改框时清空所有的批改值
      this.radioValue = "";
      this.activeSecondName = "拼写错误";
      this.activeName = "扣分项";
      this.text = "";
      this.centerDialogVisible = false;
      this.conceal();
    },
    // 定义一个修改activeName和radioValue值的回调
    handleChange(value1, value2, value3, value4) {
      this.activeName = value1;
      this.activeSecondName = value2;
      this.radioValue = value3;
      this.text = value4;
    },
    handleConfirm() {
      if (this.radioValue === "") {
        this.$message({
          message: "请选择批注类型",
          type: "warning"
        });
      } else if (this.text === "") {
        this.$message({
          message: "请输入批注信息",
          type: "warning"
        });
      } else {
        this.confirm(this.radioValue, this.text);
        // 关闭批改框之前清空所有批改值
        this.radioValue = "";
        this.text = "";
        this.centerDialogVisible = false;
      }
    }
  }
};
</script>
<style>
.el-tabs .is-left .el-tabs__item {
  font-size: 17px !important;
}
.grid-content .el-radio-button:first-child .el-radio-button__inner {
  border: 0;
}
.grid-content .el-radio-button__inner {
  border: 0;
  display: inline-block;
  width: 110px;
  padding: 12px;
  overflow: hidden;
}
.bg-purple-light .el-textarea textarea {
  border: 0;
  background: #8986861a;
}
.bg-purple .el-radio-group {
  height: 270px;
  overflow: auto;
}
.c_cover .el-dialog__body {
  padding: 10px 20px;
}
.c_cover .el-dialog__footer {
  text-align: center;
}
</style>
<style scoped>
.first-el-tab {
  width: 100%;
  height: 300px;
  border: 1px solid #e7eaef;
}
.grid-content {
  height: 300px;
}
.bg-purple {
  padding: 10px 8px;
}
.bg-purple-light {
  padding: 20px;
  border-left: 1px solid #e4e7ed;
}
.others-tab {
  border: 0;
}

.bg-purple-light div:first-child {
  height: 30px;
  font-size: 18px;
  font-weight: bolder;
}
</style>
